import { createGlobalStyle } from 'styled-components';

const AccountCreateGlobalStyles = createGlobalStyle`
  /* stylelint-disable-next-line selector-disallowed-list -- refactor with ".shortcut-" prefix, or styled-components, or UxCore components */
  .ux-button .ux-button-icon {
    /* stylelint-disable-next-line declaration-no-important -- next who will be here, remove !important */
    margin: 0 8px 0 0 !important;
  }
  
  .shortcut-consent-notices-text {
    padding: 0.5rem 0;
  }
`;

export default AccountCreateGlobalStyles;
